import React from 'react';
import styled from 'styled-components';
import { useIntl, defineMessages } from 'react-intl';
import { Text } from '@companycam/slab-web';

import AssignedUserItem from 'components/shared/AssignUsers/AssignedUserItem';
import { AssignedUserObject } from 'data/v3/data-contracts';

// #region styled-components
const EmptyStateContainer = styled.div`
  text-align: center;
  margin-top: var(--cc_size_spacing_m);
`;
// #endregion

const messages = defineMessages({
  assignUserEmptyStateMessage: {
    id: 'AssignUsers.emptyStateMessage',
    defaultMessage: 'Assign to one or multiple users',
    description: 'Message when there are no assigned users',
  },
});

const EmptyState = ({ message }: { message: string }) => (
  <EmptyStateContainer>
    <Text size="s" as="p" color="subtle">
      {message}
    </Text>
  </EmptyStateContainer>
);

type AssignedUsersProps = {
  assignedUsers: AssignedUserObject[];
  onRemoveUser: (id: AssignedUserObject['id']) => void;
};

const AssignedUsers = ({ assignedUsers, onRemoveUser }: AssignedUsersProps) => {
  const { formatMessage } = useIntl();

  return assignedUsers.length === 0 ? (
    <EmptyState message={formatMessage(messages.assignUserEmptyStateMessage)} />
  ) : (
    <ul>
      {assignedUsers.map((assignedUser) => {
        return (
          <AssignedUserItem
            key={assignedUser.id}
            assignedUser={assignedUser}
            onRemoveUser={onRemoveUser}
          />
        );
      })}
    </ul>
  );
};

export default AssignedUsers;
